angular.module('iconoglobe')
.factory('MapboxGeoService',['$q', '$http', function($q, $http){
  var accessToken = "pk.eyJ1IjoibG91aXNwIiwiYSI6ImNpeHVvd3ZxYzAwM2szMnQ5N2Q1cjB0Z2oifQ.1aIlYGHSc1LXrvhI2GXA9w";
  var baseUrl = "//api.mapbox.com/v4/geocode/mapbox.places/";
  var baseEnd = ".json?access_token=" + accessToken;
  var getAddress = function(place){
    var deferred= $q.defer();
    $http.get(baseUrl + place + baseEnd)
    .then(function(res){
      deferred.resolve(res.data);
    }, function(error){
      deferred.reject();
    });
    return deferred.promise;
  };
  var getGeo = function(place){
    var deferred= $q.defer();
    $http.get(baseUrl + place + baseEnd)
    .then(function(res){
      deferred.resolve(res.data);
    }, function(error){
      deferred.reject();
    });
    return deferred.promise;
  };
 
  return {
    getAddress : getAddress,
    getGeo : getGeo
  };
}]);